import { useNavigate } from "react-router-dom";

export const StoreButtons = () => {
  const navigate = useNavigate();

  const goToGuestHome = () => navigate("/");

  const buttons = [
    {
      href: "https://couponbook.app.link/BsnZ5PEfH2b",
      src: "/images/AppleLogo.png",
      alt: "Download on the App Store",
    },
    {
      href: "https://couponbook.app.link/BsnZ5PEfH2b",
      src: "/images/rectangle-34625679.png",
      alt: "Get it on Google Play",
    },
  ];

  const buttonClass = `
    flex items-center justify-center
    w-[300px] max-[768px]:w-[260px] h-12 md:w-[160px] md:h-12 min-[1200px]:w-[210px] min-[1200px]:h-14
    bg-black rounded-[30px]
    relative
    before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-[30px]
    before:[background:linear-gradient(90deg,rgba(0,0,0,1)_0%,rgba(0,0,0,1)_100%)]
    before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
    before:[-webkit-mask-composite:xor] before:[mask-composite:exclude]
    before:z-[1] before:pointer-events-none
    hover:opacity-90 transition-opacity
    focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black
  `;

  return (
    <div className="flex flex-col gap-3">
      <div
        role="group"
        aria-label="Download app buttons"
        className="flex flex-col gap-3 min-[768px]:flex-row  sm:items-center sm:gap-4"
      >
        {buttons.map(({ src, alt, href }) => (
          <a
            key={alt}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={alt}
            className={buttonClass}
          >
            <img
              src={src}
              alt={alt}
              className="w-[120px] min-[1200px]:w-[162px] min-[1200px]:h-[38px] object-contain"
            />
          </a>
        ))}
      </div>

      <button
        onClick={goToGuestHome}
        aria-label="View deals now"
        className="
          flex items-center justify-center
          w-[300px] max-[768px]:w-[260px] h-12 md:w-[334px] md:h-12 min-[1200px]:w-[430px] min-[1200px]:h-14
          bg-black rounded-[30px]
          text-white font-semibold text-[16px] min-[1200px]:text-[18px]
          hover:opacity-90 transition-opacity
          focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black
        "
      >
        View Deals Now in Browser!
      </button>
    </div>
  );
};